<template>
  <!-- <div class="wrap_processbox wow fadeInUp">
    <div class="block_div"></div>

  <titleBlock textChinese="服务流程" textEnglish="SERVICE PROCESS" colorIndex='1' />

<div class="wrap_process ">
                    <div  class="wrap_process1"> <img :src="require('@/assets/imgs/process1.png')"> </div>
                    <div  class="wrap_process2"><img :src="require('@/assets/imgs/process2.png')"> </div>
                    <div  class="wrap_process3"> <img :src="require('@/assets/imgs/process3.png')"> </div>
                    <div  class="wrap_process4"> <img :src="require('@/assets/imgs/process4.png')"> </div>
                    <div  class="wrap_process5"> <img :src="require('@/assets/imgs/process5.png')"> </div>
                    <div  class="wrap_process6"> <img :src="require('@/assets/imgs/process6.png')"> </div>
                    <div  class="wrap_process7"> <img :src="require('@/assets/imgs/process7.png')"> </div>
                    <div  class="wrap_process8"> <img :src="require('@/assets/imgs/process8.png')"> </div>

                    <div  class="wrap_process9"> 项目立项</div>
                    <div  class="wrap_process10"> 创意大纲撰写</div> 
                    <div  class="wrap_process11"> 脚本撰写</div>
                    <div  class="wrap_process12"> 演员匹配</div>
                    <div  class="wrap_process13"> 组织拍摄</div>
                    <div  class="wrap_process14"> 后期剪辑</div>
                    <div  class="wrap_process15"> 成片交付</div>
                </div>
  </div>-->
  <div class="wrap_processbox wow fadeInUp flow">
    <div class="fp-tableCell">
      <!-- <div class="title">
        <h1 class="title-text">服务流程</h1>
        <p class="title-description">1000多家企事业单位认可的移动应用构建流程，科学组织，提高开发效率。</p>
      </div>-->
      <div class="block_div"></div>
      <titleBlock textChinese="服务流程" textEnglish="SERVICE PROCESS" colorIndex="1" />
      <div class="inner-item">
        <div class="i-process end">
          <div class="list clearfix">
            <div class="btn h poa t-c" style="transform: translate(0px, 0px); opacity: 1;">
              <p>项目立项</p>
              <div class="light por"></div>
              <div class="circle por t-f fl"></div>
            </div>
            <div class="btn h poa t-c" :class="selectIndex===1?'cur':''" style="transform: translate(0px, 0px); opacity: 1;">
              <div class="circle por t-f fl"></div>
              <div class="light por"></div>
              <p>项目立项</p>
            </div>
            <div class="btn h poa t-c" :class="selectIndex===2?'cur':''"  style="transform: translate(0px, 0px); opacity: 1;">
              <p class="super_idea">创意大纲撰写</p>
              <div class="light por"></div>
              <div class="circle por t-f fl"></div>
            </div>
            <div class="btn h poa t-c" :class="selectIndex===3?'cur':''" style="transform: translate(0px, 0px); opacity: 1;">
              <div class="circle por t-f fl"></div>
              <div class="light por"></div>
              <p>脚本撰写</p>
            </div>
            <div class="btn h poa t-c" :class="selectIndex===4?'cur':''"  style="transform: translate(0px, 0px); opacity: 1;">
              <p>演员匹配</p>
              <div class="light por"></div>
              <div class="circle por t-f fl"></div>
            </div>
            <div class="btn h poa t-c"  :class="selectIndex===5?'cur':''" style="transform: translate(0px, 0px); opacity: 1;">
              <div class="circle por t-f fl"></div>
              <div class="light por"></div>
              <p>组织拍摄</p>
            </div>
            <div class="btn h poa t-c" :class="selectIndex===6?'cur':''"  style="transform: translate(0px, 0px); opacity: 1;">
              <p>后期剪辑</p>
              <div class="light por"></div>
              <div class="circle por t-f fl"></div>
            </div>
            <div class="btn h poa t-c" :class="selectIndex===7?'cur':''"  style="transform: translate(0px, 0px); opacity: 1;">
              <div class="circle por t-f fl"></div>
              <div class="light por"></div>
              <p>成片交付</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleBlock from "@/components/titleBlock.vue";

export default {
  name: "serviceProgress",
  components: {
    titleBlock
  },
  // props: {
  //   videoArray: {
  //     type: Array,
  //     default: () => {
  //       return []
  //     },
  //   }
  // },
  data() {
    return {
      selectIndex:1,
      // serviceArray:[
      //   {url:require('@/assets/imgs/a01.png'),title:'商业视频',titleEng:'Commercial video'},
      //   {url:require('@/assets/imgs/a02.png'),title:'短视频',titleEng:'short video'},
      //   {url:require('@/assets/imgs/a01.png'),title:'视频课程',titleEng:'video course'},
      //   {url:require('@/assets/imgs/a03.png'),title:'多媒体展示',titleEng:'multimedia show'},
      // ],
    };
  },
  mounted() {
     setInterval(()=>{
        this.selectIndex = this.selectIndex + 1
        if (this.selectIndex === 8) {
          this.selectIndex = 1
        }
      },3000)
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live: true
      }).init();
    });
  }

  // mounted(){
  // 　　window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  // },
  // methods:{
  //   handleScroll(){
  //     this.$nextTick(()=>{
  // 	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  //    if (scrollTop > 60) {
  //      this.logoIndex = 1
  //      this.classNames = "nav_bg_white_add"
  //      this.menuClassNames = "menu_each each_toggle"
  //       } else {
  //      this.logoIndex = 0
  //      this.classNames = "nav_bg_white_reduce"
  //      this.menuClassNames = "menu_each "
  //       }
  // })
  //   }
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_processbox {
  background: url("../assets/imgs/bg.png") center no-repeat;
  background-size: cover;
  /* 必要布局样式css */
  .i-process .list {
    background: url("../assets/imgs/line.png") no-repeat center;
    margin: 0 auto;
    width: 1210px;
    height: 333px;
  }

  .fl {
    float: left;
    display: inline;
  }

  .fr {
    float: right;
    display: inline;
  }

  .por {
    position: relative;
  }

  .poa {
    position: absolute;
  }

  .flow,
  .cooperation {
    background-color: #fff;
  }

  .flow {
    height: 685px;
    text-align: center;
  }

  .fp-tableCell {
  }

  .title {
    padding: 60px 0 80px 0;
  }

  .title-text {
    position: relative;
    padding-bottom: 20px;
    font-size: 34px;
    color: #666666;
    font-weight: normal;
  }

  .title-text:after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 110px;
    height: 6px;
    margin-left: -52px;
    background-color: #43cdab;
  }

  .title-description {
    margin-top: 40px;
    color: #b0b0b0;
  }

  .title-description { 
    margin-top: 30px;
  }

  .inner-item {
    margin: 0 auto;
    position: relative;
  }

  .i-process {
    position: relative;
    width: 1210px;
    margin: 0 auto;
  }

  .i-process .hold {
    width: 1106px;
    height: 352px;
    margin: 0 auto;
  }

  .i-process .btn {
    width: 68px;
    height: 150px;
    line-height: 2;
    color: #f7c033;
    text-align: center;
    transform: translateX(50px);
    opacity: 0;
  }

  .i-process .btn.cur {
    color: #f7c033;
  }

  .i-process .btn:nth-child(1) {
    // left: 33px;
    // top: 165px;
    display: none;
  }

  .i-process .btn:nth-child(2) {
    left: 92px;
    top: 77px;
  }

  .i-process .btn:nth-child(3) {
    left: 264px;
    top: 116px;
  }

  .i-process .btn:nth-child(4) {
    left: 439px;
    top: 46px;
  }

  .i-process .btn:nth-child(5) {
    left: 618px;
    top: 54px;
  }

  .i-process .btn:nth-child(6) {
    left: 776px;
    top: 42px;
  }

  .i-process .btn:nth-child(7) {
    left: 957px;
    top: 148px;
  }

  .i-process .btn:nth-child(8) {
    left: 1087px;
    top: 58px;
  }
  .super_idea {
    width: 120px;
    margin-left: -24px;
    text-align: center;
  }
  .i-process .btn .light {
    float: left;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background: #fff;
    margin: 12px 29px;
  }

  .i-process .btn .light:after {
    content: "";
    position: absolute;
    left: -5px;
    top: -5px;
    z-index: -1;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: #f7c033;
    opacity: 0.3;
  }

  .i-process .btn.cur .light:after {
    animation: Circle 1.2s infinite linear;
  }

  .i-process .btn.cur .light:after {
    animation: Circle 1.2s infinite linear;
  }

  .i-process .btn .circle {
    width: 68px;
    height: 68px;
    border-radius: 34px;
    // background: #edeff1;
    border: 1px solid #f7c033;
    margin: 12px 0;
  }

  .i-process .btn.cur .circle {
    background: #f7c033;
  }

  .i-process .btn .circle:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 68px;
    height: 68px;
    background: url(../assets/imgs/bg_sign06.png) no-repeat;
  }

  .i-process .btn.cur .circle:after {
    background-position: 0 -68px;
  }

  .i-process .btn:nth-child(2) .circle:after {
    background-image: url(../assets/imgs/bg_sign07.png);
  }

  .i-process .btn:nth-child(3) .circle:after {
    background-image: url(../assets/imgs/bg_sign08.png);
  }

  .i-process .btn:nth-child(4) .circle:after {
    background-image: url(../assets/imgs/bg_sign09.png);
  }

  .i-process .btn:nth-child(5) .circle:after {
    background-image: url(../assets/imgs/bg_sign10.png);
  }

  .i-process .btn:nth-child(6) .circle:after {
    background-image: url(../assets/imgs/bg_sign11.png);
  }

  .i-process .btn:nth-child(7) .circle:after {
    background-image: url(../assets/imgs/bg_sign12.png);
  }

  .i-process .btn:nth-child(8) .circle:after {
    background-image: url(../assets/imgs/bg_sign13.png);
  }

  .i-process {
    /* height: 350px; */
  }

  .w-f {
    width: 100%;
  }

  .h-f {
    height: 100%;
  }

  .fwn {
    font-weight: normal;
  }

  .tac {
    text-align: center;
  }

  .t-f {
    transition: all 0.5s;
  }

  .t-c {
    transition: color 0.5s;
  }

  .t-bg {
    transition: background 0.5s;
  }

  @keyframes Circle {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }

    50% {
      transform: scale(1);
      opacity: 0.3;
    }

    100% {
      transform: scale(0.5);
      opacity: 0;
    }
  }
}
// .wrap_processbox{
//   background: url('../assets/imgs/bg.png') center no-repeat;
//     background-size: cover;
// }
// .wrap_process{
//     width: 1210px;
//     margin: 0 auto;
//     height: 500px;
//     position: relative;
// }
// .wrap_process1{
//     position: absolute;
//     top: 195px;
//     left: 39px;
//     width: 1125px;

// }
// .wrap_process2{
//     position: absolute;
//     top: 97px;
//     left: 13px;
//     width: 72px;

// }
// .wrap_process3{
//     position: absolute;
//     top: 97px;
//     left: 380px;
//     width: 72px;

// }
// .wrap_process4{
//     position: absolute;
//     top: 96px;
//     left: 751px;
//     width: 72px;

// }
// .wrap_process5{
//     position: absolute;
//     top: 97px;
//     left: 1121px;
//     width: 72px;

// }
// .wrap_process6{
//     position: absolute;
//     top: 332px;
//     left: 196px;
//     width: 72px;

// }
// .wrap_process7{
//     position: absolute;
//     top: 331px;
//     left: 567px;
//     width: 72px;

// }
// .wrap_process8{
//     position: absolute;
//     top: 332px;
//     left: 938px;
//     width: 72px;

// }
// .wrap_process9{
//     /* 261 51 */
//     position: absolute;
//     top: 51px;
//     left: 10px;
//     width: 84px;
//     height: 28px;
//     min-height: 40px;
//     font-size: 18px;
//     color: #F7C033;
// }

// .wrap_process10{
//     position: absolute;
//     top: 51px;
//     left: 363px;
//     width: 120px;
//     height: 28px;
//     min-height: 40px;
//     font-size: 18px;
//     color: #F7C033;
// }
// .wrap_process11{
//     position: absolute;
//     top: 51px;
//     left: 746px;
//     width: 84px;
//     height: 28px;
//     min-height: 40px;
//     font-size: 18px;
//     color: #F7C033;
// }
// .wrap_process12{
//     position: absolute;
//     top: 51px;
//     left: 1113px;
//     width: 84px;
//     height: 28px;
//     min-height: 40px;
//     font-size: 18px;
//     color: #F7C033;
// }
// .wrap_process13{
//     position: absolute;
//     top: 420px;
//     left: 190px;
//     width: 84px;
//     height: 28px;
//     min-height: 40px;
//     font-size: 18px;
//     color: #F7C033;
// }
// .wrap_process14{
//     position: absolute;
//     top: 420px;
//     left: 562px;
//     width: 84px;
//     height: 28px;
//     min-height: 40px;
//     font-size: 18px;
//     color: #F7C033;
// }
// .wrap_process15{
//     position: absolute;
//     top: 420px;
//     left: 935px;
//     width: 84px;
//     height: 28px;
//     min-height: 40px;
//     font-size: 18px;
//     color: #F7C033;
// }
</style>



